/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertFlatItemsToTree } from 'utils/tree';

import { CustomFieldSelectAttributeOption } from '../types/customFields.types';
import {
  CreateAttributeApiResponse,
  ReadAttributesApiResponse,
  UpdateAttributeApiResponse,
} from '../types/customFieldsApi.types';

/**
 * Transforms the read attributes response.
 *
 * @param response The raw response from read attributes endpoint.
 */
export function transformReadAttributesResponse(
  response: any,
): ReadAttributesApiResponse {
  const { data: attributes, meta } = response;

  attributes
    .sort((a, b) => a.order_index - b.order_index)
    .forEach(transformAttribute);

  return {
    data: {
      attributes,
    },
    meta,
  };
}

/**
 * Transforms the create attributes response.
 *
 * @param response The raw response from create attributes endpoint.
 */
export function transformCreateAttributeResponse(
  response: any,
): CreateAttributeApiResponse {
  const { data: attribute, meta } = response;

  transformAttribute(attribute);

  return {
    data: attribute,
    meta,
  };
}

/**
 * Transforms the update attributes response.
 *
 * @param response The raw response from update attributes endpoint.
 */
export function transformUpdateAttributeResponse(
  response: any,
): UpdateAttributeApiResponse {
  const { data: attribute, meta } = response;

  transformAttribute(attribute);

  return {
    data: attribute,
    meta,
  };
}

function transformAttribute(attribute: any): void {
  if ('options' in attribute) {
    attribute.options = transformSelectAttributeOptionsResponse(
      attribute.options,
    );
  }
}

function transformSelectAttributeOptionsResponse(
  options: Record<string, unknown>,
): readonly CustomFieldSelectAttributeOption[] {
  return convertFlatItemsToTree<
    Omit<CustomFieldSelectAttributeOption, 'options'>,
    'id',
    'parent_id',
    keyof Pick<CustomFieldSelectAttributeOption, 'options'>
  >(
    Object.values(options) as readonly Omit<
      CustomFieldSelectAttributeOption,
      'options'
    >[],
    {
      idKey: 'id',
      parentIdKey: 'parent_id',
      childrenKey: 'options',
      sortFn: (a, b) => a.order_index - b.order_index,
    },
  );
}
